import { ArrowRight } from "lucide-react";
import { Button } from "../ui/Button";
import { Section } from "../ui/Section";

export function FinalCtaSection() {
  return (
    <Section className="py-12 sm:py-16">
      <div className="glass-panel rounded-[1.75rem] px-5 py-8 text-center shadow-[0_28px_85px_rgb(0_0_0_/_0.28)] sm:px-8 sm:py-10">
        <h2 className="text-3xl font-bold text-white sm:text-4xl">Έτοιμος να δοκιμάσεις τις δυνατότητές σου;</h2>
        <p className="mx-auto mt-3 max-w-2xl text-slate-300">
          Ξεκίνα το Brain Test και δες πώς αποδίδεις σε μοτίβα, λογική, ακολουθίες και ταχύτητα σκέψης.
        </p>
        <Button href="/test" className="mt-6 w-full sm:w-auto">
          Ξεκίνα το IQ Test <ArrowRight className="ml-2" size={18} />
        </Button>
        <p className="mt-3 text-sm text-slate-400">Δεν απαιτείται λογαριασμός για να ξεκινήσεις.</p>
      </div>
    </Section>
  );
}
